import React, { Fragment } from 'react';
import { components } from 'react-select';
import { css, cx } from '@emotion/css';
import { theme } from '@branchjs/neo-components';
import Icons from '../../../../../styles/Icons';
import { strToTitleCase } from '../../../../main/support/utils';

const Input = (props) => {
  const searchIcon = css({
    fontFamily: 'Material Icons',
    fontSize: 18,
    fontStyle: 'normal',
    color: theme.colors.gray[400],
    marginLeft: 10,
    marginBottom: 6,
  });
  return (
    <Fragment>
      <i className={searchIcon}>{Icons.SEARCH}</i>
      <components.Input {...props} className="Select-input Select__input" />
    </Fragment>
  );
};

const Option = (props) => {
  const {
    label,
    isFocused,
    data,
    selectProps: { secondaryLabelKey },
  } = props;

  const secondaryLabel = secondaryLabelKey ? data[secondaryLabelKey] : undefined;

  const backgroundColor = isFocused ? theme.colors.gray[100] : undefined;
  const styles = {
    container: css({
      display: 'flex',
      justifyContent: 'space-between',
      height: 30,
      borderRadius: 5,
      color: theme.colors.gray[800],
      fontSize: theme.typography.body2.fontSize,
      margin: '0px 8px',
      padding: '5px 0px',
      alignItems: 'center',
      backgroundColor,
    }),
    label: css({
      paddingLeft: 8,
    }),
    secondaryLabel: css({
      paddingRight: 12,
      color: theme.colors.sidebar.baseColor,
      opacity: 0.2,
    }),
  };

  const titleCaseSecondaryLabel = secondaryLabel && strToTitleCase(secondaryLabel);
  return (
    <div {...props.innerProps}>
      <div className={styles.container}>
        <div className={cx(styles.label, 'Select-option, Select__option')}>{label}</div>
        {secondaryLabel && <div className={styles.secondaryLabel}>{titleCaseSecondaryLabel}</div>}
      </div>
    </div>
  );
};

const customComponents = {
  Input,
  Option,
  DropdownIndicator: () => null,
};

export default customComponents;
